import { ApolloClient, ApolloQueryResult, NormalizedCacheObject } from '@apollo/client';
import { handleQuery } from '@99designs/graph-utils';
import { InspirationDocument } from '../graphql/Inspiration.generated';
import type { Design } from '@99designs/feature-design-inspiration';
import type { InspirationQuery } from '../graphql/Inspiration.generated';

export async function getDesignInspirations(
    client: ApolloClient<NormalizedCacheObject>,
    categoryKeys: string[],
    industries?: string[]
): Promise<Design[]> {
    const { data, error } = await fetchDesignInspirations(client, categoryKeys, industries);

    if (error) {
        throw error;
    }

    if (!data) {
        return [];
    }

    return data.discoverDesigns.designs;
}

function fetchDesignInspirations(
    client: ApolloClient<NormalizedCacheObject>,
    categoryKeys: string[],
    industries?: string[]
): Promise<ApolloQueryResult<InspirationQuery>> {
    return handleQuery<InspirationQuery>(client, {
        query: InspirationDocument,
        variables: {
            input: {
                categories: categoryKeys,
                industries: industries,
                pageSize: 10,
                page: 1,
            },
        },
    });
}
